import { Component, OnInit } from "@angular/core";
import { LoaderService } from "src/app/services/loader.service";

@Component({
    selector: 'app-loader',
    template: `<div class="loader-overlay" [hidden]="!loading"><div class="lds-ripple"><div></div><div></div></div></div>`,
    styles: [
    ]
})
export class LoaderComponent implements OnInit {
    
    
    loading: boolean;

  constructor(private loaderService: LoaderService) {

    this.loaderService.isLoading.subscribe((v) => {
     // console.log(v);
      this.loading = v;
    });

  }
  ngOnInit() {
  }

}